import { connect } from 'react-redux';
import { Homepage } from './component';
import { selectIsLoggedIn } from '../../../ReduxStorage/Auth/selectors';
import { selectFeaturedCourses, selectFeaturedPartners } from './selectors';

export const ConnectedHomepage = connect((state) => ({
  isLoggedIn: selectIsLoggedIn(state),
  featuredCourses: selectFeaturedCourses(state),
  featuredPartners: selectFeaturedPartners(state),
}))(Homepage);
